import { State } from 'src/replicant/State';
import { match2DailyChallenges } from './match2-dailychallenge.ruleset';
import { getJSTDate } from 'src/replicant/utils/time';
import { duration } from 'src/replicant/utils/duration';

export function getDailyChallengeDay(now: number): number {
  return getJSTDate(now).getDay(); // 0-6, 0 = Sunday
}

export function getDailyChallengeRemainingTime(now: number): number {
  const elapsed =
    getJSTDate(now).getTime() - getJSTDate(now).setHours(0, 0, 0, 0);
  return duration({ hours: 24 }) - elapsed;
}

export function getDailyChallenge(day: number) {
  return match2DailyChallenges[day];
}

export function getDailyChallengeId(state: State) {
  if (!state.match2.dailyChallenge) return null;
  const day = state.match2.dailyChallenge.day;
  const challenge = getDailyChallenge(day);
  return challenge?.id ?? null;
}

export function getDailyChallengeConfig(state: State) {
  if (!state.match2.dailyChallenge) return null;
  const day = state.match2.dailyChallenge.day;
  const challenge = getDailyChallenge(day);
  if (!challenge) return null;
  const level = state.match2.dailyChallenge.startingLevel;
  const config = challenge.configs.find((config) => {
    const minLevel = config.minLevel ?? 1;
    const maxLevel = config.maxLevel ?? Infinity;
    return level >= minLevel && level <= maxLevel;
  });

  return config ?? null;
}

export function getDailyChallengeRewardGems(state: State): number {
  if (!state.match2.dailyChallenge) return 0;
  const config = getDailyChallengeConfig(state);
  if (!config) return 0;
  return config.rewardGems;
}

export function shouldSyncDailyChallenge(state: State, now: number): boolean {
  if (!state.match2.dailyChallenge) {
    return false;
  }

  // It should also NOT sync if feature is not yet available
  if (!isDailyChallengeAvailable(state)) return false;

  const day = getDailyChallengeDay(now);

  // It should sync if the current day is different from the stored day
  return day !== state.match2.dailyChallenge.day;
}

export function isDailyChallengeAvailable(state: State): boolean {
  return state.tutorial.basicGameplayShown;
}
export function isDailyChallengeComplete(state: State): boolean {
  if (!state.match2.dailyChallenge) return false;
  const config = getDailyChallengeConfig(state);
  if (!config) return false;
  return state.match2.dailyChallenge.progress >= config.requirement;
}
